import { CompanyDetailsPage, SettingsPageWrapper } from "@shared/ui/Settings";
import { useParams } from "react-router-dom";
import { EntityType } from "@shared/types/commonTypes";

const CompanyDetails: React.FC = () => {
  const params = useParams<{ clinicId: string }>();
  const companyId = params.clinicId!;
  return (
    <SettingsPageWrapper entityType={EntityType.CLINIC} entityId={companyId}>
      <CompanyDetailsPage companyId={companyId} />
    </SettingsPageWrapper>
  );
};

export default CompanyDetails;
